{
    "InsightsDashboard_Title": "Percepções",
    "InsightsDashboard_BusinessFilter": "Filtro de negócios",
    "InsightsDashboard_AllPartitions": "Todos os sites",
    "InsightsDashboard_CallsReceived": "Chamadas recebidas",
    "InsightsDashboard_MissedCalls": "Chamadas perdidas",
    "InsightsDashboard_AverageAnswer": "Resposta média",
    "InsightsDashboard_AverageAbandoned": "Média Abandonada",
    "InsightsDashboard_LongestWait": "Espera mais longa",
    "InsightsDashboard_VsLastWeekCurrently": "Atualmente",
    "InsightsDashboard_PercentVsLastWeek": "**{}%** vs Semana Anterior",
    "InsightsDashboard_VsLastWeek": "**{}** vs Semana Passada",
    "InsightsDashboard_BusiestDay": "Dia mais movimentado",
    "InsightsDashboard_PeakCalls": "Chamadas de pico",
    "InsightsDashboard_MostCalledInboundNumber": "Número de entrada mais chamado",
    "InsightsDashboard_MostAnsweredCalls": "Chamadas mais atendidas",
    "InsightDashboard_CalledNumber": "Número chamado",
    "InsightsDashboard_User": "Usuário",
    "InsightsDashboard_SecondsDisplay": "{}s",
    "InsightsDashboard_Tooltip_TimeLabel": "Hora: {}:00",
    "InsightsDashboard_Tooltip_DayLabel": "Dia: {}",
    "InsightsDashboard_Tooltip_CallsLabel": "Número de chamadas: {}",
    "InsightsDashboard_Tooltip_Stats_0": "Chamadas recebidas: {}",
    "InsightsDashboard_Tooltip_Stats_1": "Chamadas perdidas: {}",
    "InsightsDashboard_Tooltip_Stats_2": "Média de respostas: {}",
    "InsightsDashboard_Tooltip_Stats_3": "Média de Abandono: {}",
    "InsightsDashboard_Tooltip_Stats_4": "Espera mais longa: {}",
    "InsightsDashboard_Tooltip_Stats_WeekCommencing": "Semana de início: {}",
    "InsightsDashboard_OfLast30Days": "dos últimos 30 dias",
    "InsightsDashboard_OverLast30Days": "Nos últimos 30 dias",
    "InsightsDashboard_OverLast7Days": "Nos últimos 7 dias",
    "InsightsDashboard_ThisWeek": "Essa semana",
    "InsightsDashboard_LastWeek": "Semana passada",
    "InsightsDashboard_PrevWeek": "Semana Anterior",
    "InsightsDashboard_ErrorState_Message": "Lamentamos que tenha ocorrido um problema. \n Atualize seu navegador. \n \n {}",
    "InsightsDashboard_ErrorState_No_TelSys_Or_Partition": "Nenhum servidor de telefonia ou partição selecionada",
    "InsightsDashboard_Tour_Step_1": "Aqui você seleciona seu negócio e site",
    "InsightsDashboard_Tour_Step_2": "Veja as métricas de ponto de contato do seu negócio nos últimos 30 dias: \n ##?##Dias mais movimentados, permitindo que você programe melhor os recursos####Horários mais movimentados, esteja pronto com cobertura nos horários de pico para não perder chamadas####?",
    "InsightsDashboard_Tour_Step_3": "Principais métricas de desempenho de chamadas nos últimos 30 dias: \n ##?##Número total de chamadas recebidas pela sua empresa####Chamadas perdidas####Tempos médios de atendimento e abandono####Maior tempo em que uma chamada ficou em espera####? \n Clique nas métricas para obter comparações e tendências semanais.",
    "InsightsDashboard_Tour_Step_4": "Identifique os DDIs recebidos mais frequentemente discados nos últimos 7 dias, bem como quais usuários atendem mais chamadas. Isso exibirá os 10 principais.",
    "InsightsDashboard_Tour_Step_5": "Clique aqui para abrir o portal de relatórios",
    "InsightsDashboard_Tour_Step_6": "Clique aqui para abrir o portal de relatórios",
    "NAME": "InsightsDashboardLanguage"
}